export class RecordSummaryTrendPointDto {
  from!: Date;
  to!: Date;
  total!: number;
  byStatus!: Record<string, number>;
}
